import { MultiDisciplineAbout } from "../components/about/MultiDisciplineAbout";

export function meta() {
  return [{ title: "About — Captures by Mari" }];
}

export default function AboutRoute() {
  return <MultiDisciplineAbout />;
}
